import React, { useEffect, useState } from "react";
import { CustomInput } from "../../../../components/main_comps/custom_input/CustomInput";
import "../../../../../App.css";
import { CustomButton } from "../../../../components/main_comps/custom_button";

import { AiOutlineEye } from "react-icons/ai";
import {
  Add,
  SymAdd,
  Upwardarrow,
  UpwardArrow,
} from "../../../../../utility/constants/assetsManager";
import CustomUploadField from "../../../../components/ui_comps/CustomUploadField";
import CustomUploadField2 from "../../../../components/ui_comps/CustomUploadField2";
import { checkObjHasAllValue } from "../../../../components/ui_comps/ComissionContainer";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router";

function DocumentDetailsNew({
  onClickNext,
  onClickPrevious,
  reduxData,
  onClickCancel,
}) {
  const [pan, setPan] = useState("");
  const [aadhar, setAadhar] = useState("");
  const [shopCertificate, setShopCertificate] = useState("");
  const [udyogAadhar, setUdyogAadhar] = useState("");
  const [signedSla, setSignedSla] = useState("");
  const [nda, setNda] = useState("");
  const [others, setOthers] = useState("");
  const [others2, setOthers2] = useState("");
  const [gstCertificate, setGstCertificate] = useState("");
  const [incorporationCertificate, setIncorporationCertificate] = useState("");
  const [cancelledCheque, setCancelledCheque] = useState("");
  const [kyc, setKyc] = useState("");
  const [memorandum, setMemorandum] = useState("");
  const [associationArticle, setAssociationArticle] = useState("");
  const [merchantApproval, setMerchantApproval] = useState("");
  const [partnershipDeeds, setPartnershipDeeds] = useState("");

  const [agreement, setAgreement] = useState("");
  const [merchantOnboarding, setMerchantOnboarding] = useState("");
  const [upi, setUpi] = useState("");
  const [addLength, setAddlength] = useState([]);

  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const inputStyle = {
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    color: "#000000",
  };
  const containerStyle = {
    minWidth: "343px",
    height: "44px",
    left: "calc(50% - 343px/2)",
    top: "24px",
    background: "#FFFFFF",
    border: "1px solid #CBCACA",
    borderRadius: "6px",
    color: "#697D95",
    margin: "5px 0 20px 0",
    paddingLeft: "10px",
  };

  console.log(reduxData)

  useEffect(() => {
    if (reduxData) {
      setPan(reduxData?.panCardUrl ?? "");
      setSignedSla(reduxData?.uploadSignedSlaUrl ?? "");
      setNda(reduxData?.ndaCertificateUrl ?? "");
      setCancelledCheque(reduxData?.cancelledChequeUrl ?? "");
      setUdyogAadhar(reduxData?.udyogCertificateUrl ?? "");
      setAadhar(reduxData?.aadharUrl ?? "");
      setShopCertificate(reduxData?.shopAndEstablishmentCertificateUrl ?? "");
      setAgreement(reduxData?.agreementUrl ?? "");
      setMerchantOnboarding(reduxData?.merchantOnboardingUrl ?? "");
      setUpi(reduxData?.upiRequestForm ?? "");
      setOthers(reduxData?.others ?? "");
      setPartnershipDeeds(reduxData?.partnershipDeedsUrl ?? "");

      setMerchantApproval(reduxData?.merchantApprovalFormUrl ?? "");
      setGstCertificate(reduxData?.gstCertificateUrl ?? "");
      setIncorporationCertificate(reduxData?.incorporationCertificateUrl ?? "");
      setMemorandum(reduxData?.memorandumOfAssociationUrl ?? "");
      setKyc(reduxData?.kycSigningAuthorityUrl ?? "");
      setAssociationArticle(reduxData?.articleOfAssociationUrl ?? "");
    }
  }, [reduxData]);

  return (
    <div
      style={{
        width: "100%",
        alignItems: "center",
        //height: "100%",
        marginTop: "20px",
        position: "absolute",
      }}
    >
      <div>
        <p style={styles.title}>Upload Documents </p>
      </div>
      <p style={styles.p}>Provide the Valid Documents as Mentioned below</p>

      <div
        style={{
          margin: "10px 0 20px 0",
          height: "1px",
          background: "#38369C",
        }}
      ></div>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "0px 100px",
        }}
      >
        <div style={{}}>
          <p style={styles.docName}>PAN</p>
          <CustomUploadField2
            document="PAN"
            customIcon={<Upwardarrow />}
            value={pan}
            // value={pan}
            onChange={(data) => {
              setPan(data);
            }}
            onClickRemove={() => {
              setPan("");
            }}
            imageTypeArray={["pdf"]}
            filesize={10}
          />
        </div>

        <div style={{}}>
          <p style={styles.docName}>Signed SLA</p>
          <CustomUploadField2
            document="Signed SLA"
            customIcon={<Upwardarrow />}
            value={signedSla}
            // value={signedSla}
            onChange={(data) => {
              setSignedSla(data);
            }}
            onClickRemove={() => {
              setSignedSla("");
            }}
            imageTypeArray={["pdf"]}
            filesize={10}
          />
        </div>

        <div style={{}}>
          <p style={styles.docName}>NDA</p>
          <CustomUploadField2
            document="NDA"
            customIcon={<Upwardarrow />}
            // value={nda}
            value={nda}
            onChange={(data) => {
              setNda(data);
            }}
            onClickRemove={() => {
              setNda("");
            }}
            imageTypeArray={["pdf"]}
            filesize={10}
          />
        </div>

        <div style={{}}>
          <p style={styles.docName}>Onboarding Docs(UPI)</p>
          <CustomUploadField2
            document="Onboarding Docs(UPI)"
            customIcon={<Upwardarrow />}
            value={upi}
            // value={upi}
            onChange={(data) => {
              setUpi(data);
            }}
            onClickRemove={() => {
              setUpi("");
            }}
            imageTypeArray={["xlsx"]}
            accept=".xlsx"
            filesize={10}
          />
        </div>

        <div style={{}}>
          <p style={styles.docName}>Cancelled Cheque</p>
          <CustomUploadField2
            document="Cancelled Cheque"
            customIcon={<Upwardarrow />}
            // value={cancelledCheque}
            value={cancelledCheque}
            onChange={(data) => {
              setCancelledCheque(data);
            }}
            onClickRemove={() => {
              setCancelledCheque("");
            }}
            imageTypeArray={["pdf"]}
            filesize={10}
          />
        </div>

        {reduxData?.businessType === "SoleProprietorship" ||
        reduxData?.businessType === "Partnership" ? (
          <>
            <div style={{}}>
              <p style={styles.docName}>Udyog Aadhar/ Udyam Aadhar</p>
              <CustomUploadField2
                document="Udyog Aadhar/ Udyam Aadhar"
                customIcon={<Upwardarrow />}
                // value={udyogAadhar}
                value={udyogAadhar}
                onChange={(data) => {
                  setUdyogAadhar(data);
                }}
                onClickRemove={() => {
                  setUdyogAadhar("");
                }}
                imageTypeArray={["pdf"]}
                filesize={10}
              />
            </div>
            <div style={{}}>
              <p style={styles.docName}>Aadhar</p>
              <CustomUploadField2
                document="Aadhar"
                customIcon={<Upwardarrow />}
                // value={aadhar}
                value={aadhar}
                onChange={(data) => {
                  setAadhar(data);
                }}
                onClickRemove={() => {
                  setAadhar("");
                }}
                imageTypeArray={["pdf"]}
                filesize={10}
              />
            </div>
            <div style={{}}>
              <p style={styles.docName}>Shop Establishment Certificate</p>
              <CustomUploadField2
                document="Shop Establishment Certificate"
                customIcon={<Upwardarrow />}
                // value={shopCertificate}
                value={shopCertificate}
                onChange={(data) => {
                  setShopCertificate(data);
                }}
                onClickRemove={() => {
                  setShopCertificate("");
                }}
                imageTypeArray={["pdf"]}
                filesize={10}
              />
            </div>
            <div style={{}}>
              <p style={styles.docName}>Agreement</p>
              <CustomUploadField2
                document="Agreement"
                customIcon={<Upwardarrow />}
                value={agreement}
                // value={reduxData?.agreement ? reduxData.agreement : ""}
                onChange={(data) => {
                  setAgreement(data);
                }}
                onClickRemove={() => {
                  setAgreement("");
                }}
                imageTypeArray={["pdf"]}
                filesize={10}
              />
            </div>
            <div style={{}}>
              <p style={styles.docName}>Merchant Onboarding</p>
              <CustomUploadField2
                document="Merchant Onboarding"
                customIcon={<Upwardarrow />}
                // value={
                //   reduxData?.merchantOnboarding
                //     ? reduxData.merchantOnboarding
                //     : ""
                // }
                value={merchantOnboarding}
                onChange={(data) => {
                  setMerchantOnboarding(data);
                }}
                onClickRemove={() => {
                  setMerchantOnboarding("");
                }}
                imageTypeArray={["pdf"]}
                filesize={10}
              />
            </div>

            <div style={{}}>
              <p style={styles.docName}>Others</p>
              <CustomUploadField2
                document="Others"
                customIcon={<Upwardarrow />}
                value={others}
                // value={reduxData?.others ? reduxData.others : ""}
                onChange={(data) => {
                  setOthers(data);
                }}
                onClickRemove={() => {
                  setOthers("");
                }}
                imageTypeArray={["pdf"]}
                filesize={10}
              />
            </div>
          </>
        ) : (
          <></>
        )}

        {reduxData.businessType === "Partnership" ? (
          <>
            <div style={{}}>
              <p style={styles.docName}>Partnership deeds</p>
              <CustomUploadField2
                document="Partnership deeds"
                customIcon={<Upwardarrow />}
                // value={
                //   reduxData?.partnershipDeeds ? reduxData.partnershipDeeds : ""
                // }
                value={partnershipDeeds}
                onChange={(data) => {
                  setPartnershipDeeds(data);
                }}
                onClickRemove={() => {
                  setPartnershipDeeds("");
                }}
                imageTypeArray={["pdf"]}
                filesize={10}
              />
            </div>
          </>
        ) : (
          <></>
        )}

        {reduxData.businessType === "Public" ||
        reduxData.businessType === "PrivateLimited" ? (
          <>
            <div>
              <p style={styles.docName}>Merchant Approval Form</p>
              <CustomUploadField2
                document="Merchant Approval Form"
                customIcon={<Upwardarrow />}
                // value={
                //   reduxData?.merchantApprovalFormUrl
                //     ? reduxData.merchantApprovalFormUrl
                //     : ""
                // }
                value={merchantApproval}
                onChange={(data) => {
                  setMerchantApproval(data);
                }}
                onClickRemove={() => {
                  setMerchantApproval("");
                }}
                imageTypeArray={["pdf"]}
                filesize={10}
              />
            </div>
            <div>
              <p style={styles.docName}>GST certificate</p>
              <CustomUploadField2
                document="GST certificate"
                customIcon={<Upwardarrow />}
                // value={
                //   reduxData?.gstCertificateUrl
                //     ? reduxData.gstCertificateUrl
                //     : ""
                // }
                value={gstCertificate}
                onChange={(data) => {
                  setGstCertificate(data);
                }}
                onClickRemove={() => {
                  setGstCertificate("");
                }}
                imageTypeArray={["pdf"]}
                filesize={10}
              />
            </div>
            <div>
              <p style={styles.docName}>Incorporation certificate</p>
              <CustomUploadField2
                document="Incorporation certificate"
                customIcon={<Upwardarrow />}
                // value={
                //   reduxData?.incorporationCertificateUrl
                //     ? reduxData.incorporationCertificateUrl
                //     : ""
                // }
                value={incorporationCertificate}
                onChange={(data) => {
                  setIncorporationCertificate(data);
                }}
                onClickRemove={() => {
                  setIncorporationCertificate("");
                }}
                imageTypeArray={["pdf"]}
                filesize={10}
              />
            </div>
            <div>
              <p style={styles.docName}>Memorandum of Association</p>
              <CustomUploadField2
                document="Memorandum of Association"
                customIcon={<Upwardarrow />}
                value={memorandum}
                // value={
                //   reduxData?.memorandumOfAssociationUrl
                //     ? reduxData.memorandumOfAssociationUrl
                //     : ""
                // }
                onChange={(data) => {
                  setMemorandum(data);
                }}
                onClickRemove={() => {
                  setMemorandum("");
                }}
                imageTypeArray={["pdf"]}
                filesize={10}
              />
            </div>
            <div>
              <p style={styles.docName}>KYC of the signing authority</p>
              <CustomUploadField2
                document="KYC of the signing authority"
                customIcon={<Upwardarrow />}
                value={kyc}
                // value={
                //   reduxData?.kycSigningAuthorityUrl
                //     ? reduxData.kycSigningAuthorityUrl
                //     : ""
                // }
                onChange={(data) => {
                  setKyc(data);
                }}
                onClickRemove={() => {
                  setKyc("");
                }}
                imageTypeArray={["pdf"]}
                filesize={10}
              />
            </div>
            <div>
              <p style={styles.docName}>Article of Association</p>
              <CustomUploadField2
                document="Article of Association"
                customIcon={<Upwardarrow />}
                // value={
                //   reduxData?.articleOfAssociationUrl
                //     ? reduxData?.articleOfAssociationUrl
                //     : ""
                // }
                value={associationArticle}
                onChange={(data) => {
                  setAssociationArticle(data);
                }}
                onClickRemove={() => {
                  setAssociationArticle("");
                }}
                imageTypeArray={["pdf"]}
                filesize={10}
              />
            </div>
          </>
        ) : (
          <></>
        )}

        {addLength.map((e, index) => {
          return (
            <>
              <div style={{ marginTop: "10px" }}>
                <p style={styles.docName}>Others</p>
                <CustomUploadField2
                  document="Others"
                  customIcon={<Upwardarrow />}
                  value={others2}
                  // value={reduxData?.others2 ? reduxData.others2 : ""}
                  onChange={(data) => {
                    setOthers2(data);
                  }}
                  onClickRemove={() => {
                    setOthers2("");
                  }}
                  imageTypeArray={["pdf"]}
                  filesize={10}
                />
              </div>
            </>
          );
        })}
      </div>

      {/* <div
        onClick={() => {
          let temp = parseInt(addLength) + 1;
          // let temp = addLength + 1;
          setAddlength([...addLength, temp]);
        }}
        style={styles.add}
      >
        <img
          src={SymAdd}
          style={{
            height: "25px",
            width: "25px",
            padding: "5px 5px 0 5px",
            margin: "0 0 0 10px",
          }}
        />
        <p
          style={{
            color: "#001777",

            fontWeight: 500,
            fontSize: "14px",
            padding: "7px 0 0",
            color: "#001777",
          }}
        >
          Add more Documents
        </p>
      </div> */}
      <div style={{ display: "flex", marginTop: "40px", marginBottom: "30px" }}>
        <div>
          <CustomButton
            title="Cancel"
            styles={{ background: "#FDFDFD", margin: "0 15px 0 0" }}
            textStyles={{
              color: "#1E2234",

              fontWeight: "500",
              fontSize: "16px",
            }}
            onClick={onClickCancel}
          />
        </div>
        <div>
          <CustomButton
            title="Previous"
            styles={{ background: "#FDFDFD", margin: "0 15px 0 0" }}
            textStyles={{
              color: "#1E2234",

              fontWeight: "500",
              fontSize: "16px",
            }}
            onClick={onClickPrevious}
          />
        </div>
        <div>
          <CustomButton
            title="Next"
            styles={{ background: "#38369C" }}
            textStyles={{
              color: "#FDFDFD",

              fontWeight: "500",
              fontSize: "16px",
            }}
            onClick={() => {
              if (reduxData?.businessType === "Partnership") {
                if (
                  checkObjHasAllValue({
                    pan,
                    aadhar,
                    shopCertificate,
                    udyogAadhar,
                    signedSla,
                    nda,
                    upi,
                    cancelledCheque,
                    agreement,
                    merchantOnboarding,
                    partnershipDeeds,
                  })
                ) {
                  onClickNext({
                    panCardUrl: pan,
                    aadharUrl: aadhar,
                    shopAndEstablishmentCertificateUrl: shopCertificate,
                    udyogCertificateUrl: udyogAadhar,
                    uploadSignedSlaUrl: signedSla,
                    ndaCertificateUrl: nda,
                    others: others,
                    partnershipDeedsUrl: partnershipDeeds,
                    upiRequestForm: upi,
                    cancelledChequeUrl: cancelledCheque,
                    agreementUrl: agreement,
                    merchantOnboardingUrl: merchantOnboarding,
                  });
                } else {
                  enqueueSnackbar("Please upload all the files", {
                    variant: "error",
                  });
                }
              } else if (reduxData?.businessType === "SoleProprietorship") {
                if (
                  checkObjHasAllValue({
                    pan,
                    upi,
                    cancelledCheque,
                    agreement,
                    merchantOnboarding,
                    aadhar,
                    shopCertificate,
                    udyogAadhar,
                    signedSla,
                    nda,
                  })
                ) {
                  onClickNext({
                    panCardUrl: pan,
                    aadharUrl: aadhar,
                    shopAndEstablishmentCertificateUrl: shopCertificate,
                    udyogCertificateUrl: udyogAadhar,
                    uploadSignedSlaUrl: signedSla,
                    ndaCertificateUrl: nda,
                    others: others,
                    upiRequestForm: upi,
                    cancelledChequeUrl: cancelledCheque,
                    agreementUrl: agreement,
                    merchantOnboardingUrl: merchantOnboarding,
                  });
                } else {
                  enqueueSnackbar("Please upload all the files", {
                    variant: "error",
                  });
                }
              } else {
                if (
                  checkObjHasAllValue({
                    signedSla,
                    pan,
                    gstCertificate,
                    incorporationCertificate,
                    nda,
                    cancelledCheque,
                    kyc,
                    memorandum,
                    associationArticle,
                    merchantApproval,
                    upi,
                  })
                ) {
                  onClickNext({
                    uploadSignedSlaUrl: signedSla,
                    panCardUrl: pan,
                    gstCertificateUrl: gstCertificate,
                    incorporationCertificateUrl: incorporationCertificate,
                    ndaCertificateUrl: nda,
                    cancelledChequeUrl: cancelledCheque,
                    kycSigningAuthorityUrl: kyc,
                    memorandumOfAssociationUrl: memorandum,
                    articleOfAssociationUrl: associationArticle,
                    merchantApprovalFormUrl: merchantApproval,
                    upiRequestForm: upi,
                  });
                } else {
                  enqueueSnackbar("Please upload all the files", {
                    variant: "error",
                  });
                }
              }
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default DocumentDetailsNew;

const styles = {
  title: {
    fontSize: "24px",

    backgroundImage: " linear-gradient(90deg, #4947B8 0%, #FF9700 166.16%)",
    backgroundSize: "100%",
    WebkitBackgroundClip: "text",
    MozBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    MozTextFillColor: "transparent",
    fontWeight: "600",
    width: "fit-content",
  },
  p: {
    color: "#6C6B6B",

    fontWeight: "400",
    fontSize: "14px",
  },
  label: {
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    color: "#1E2234",
  },
  cancel: {
    width: "56px",
    height: "19px",

    // background: "#FDFDFD",
    border: "1px solid #38369C",
    borderRadius: "8px",
  },
  add: {
    width: "198px",
    height: "28px",
    display: "flex",
    background: "#EDEEFF",
    borderRadius: "8px",
    cursor: "pointer",
  },
  docName: {
    fontWeight: "500",
    fontSize: "12px",
    color: "#6C6B6B",
  },
};
